export default "/images/76ae9e959048d6b15dd346482b15bb8c.avif";